import React, { useEffect, useState } from 'react'
import { setLanguage, setUserName } from '../../redux/actions/language'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, useParams } from 'react-router-dom'
import '../../index.css'
import { addData } from '../../config/data'
import {
  loadCurrentApplicantCompletion,
  loadCurrentApplicantProfile,
} from '../../config/applicantApi'
import ProfileSidebar from './profileForms/ProfileSidebar'
import FamilyStructure from './profileForms/familyStructure'
import EducationForm from './profileForms/educationForm'
import ProfileDetail from './profileForms/profileDetail'
import WorkExperienceForm from './profileForms/workExperience'
import OrganizationForm from './profileForms/organizationForm'
import LicenseCertificationForm from './profileForms/licenseCertificates'
import GeneralQuestionsForm from './profileForms/generalQuestions'
import LanguageForm from './profileForms/languageForm'
import SkillsForm from './profileForms/skills'
import ProfessionalReferencesForm from './profileForms/professionalReferencesForm'
import SocialMediaForm from './profileForms/socialMedia'
import { ProfileTabProvider, useProfileTab } from './ProfileTabContext'
import { loadMyApplicationOverview } from '../myApplication/api'

const ProfilePageContent = () => {
  const { lang } = useSelector((state) => state.globalReducer)
  const { currentTabIndex } = useProfileTab()
  const [isFading, setIsFading] = useState(false)

  const dispatch = useDispatch()
  const { language } = useParams()

  const [profileData, setprofileData] = useState('')
  const [profileCompletion, setprofileCompletion] = useState(0)
  const [jobAppliedTotal, setJobAppliedTotal] = useState(0)
  const applicantID = localStorage?.getItem('applicantID')
  const userToken = localStorage?.getItem('authToken') || ''

  const loadApplicant = async () => {
    const resData = await loadCurrentApplicantProfile({ userToken })

    if (resData) {
      setprofileData(resData)
      localStorage?.setItem('localProfileData', JSON.stringify(resData))
      dispatch(setUserName(resData.fullName))
    }
  }

  useEffect(() => {
    if (!applicantID) return

    loadApplicant()
    loadPercentage()
    loadAppliedJobs()
  }, [applicantID])

  useEffect(() => {
    if (language) {
      dispatch(setLanguage(language))
    }
  }, [language])

  const updatePercentage = (value) => {
    addData({
      url: `Applicants/${applicantID}/${value}`,
      userToken,
    }).then((res) => {
      if (res?.result === true) {
        loadPercentage()
      }
    })
  }

  const tabs = [
    {
      title: 'Profile Header',
      component: (
        <ProfileDetail
          setIsFading={setIsFading}
          setPublicProfileData={setprofileData}
          updatePercentage={updatePercentage}
          profileCompletion={profileCompletion}
        />
      ),
    },
    {
      title: 'Education History',
      component: (
        <EducationForm
          setIsFading={setIsFading}
          updatePercentage={updatePercentage}
          profileCompletion={profileCompletion}
        />
      ),
    },
    {
      title: 'Organization Experience',
      component: (
        <OrganizationForm
          setIsFading={setIsFading}
          updatePercentage={updatePercentage}
          profileCompletion={profileCompletion}
        />
      ),
    },
    {
      title: 'Foreign Language Proficiency',
      component: (
        <LanguageForm
          setIsFading={setIsFading}
          updatePercentage={updatePercentage}
          profileCompletion={profileCompletion}
        />
      ),
    },
    {
      title: 'Work Experience',
      component: (
        <WorkExperienceForm
          setIsFading={setIsFading}
          updatePercentage={updatePercentage}
          profileCompletion={profileCompletion}
          setprofileData={setprofileData}
          profileData={profileData}
        />
      ),
    },
    {
      title: 'Professional References',
      component: (
        <ProfessionalReferencesForm
          setIsFading={setIsFading}
          updatePercentage={updatePercentage}
          profileCompletion={profileCompletion}
        />
      ),
    },
    {
      title: 'License Certification',
      component: (
        <LicenseCertificationForm
          setIsFading={setIsFading}
          updatePercentage={updatePercentage}
          profileCompletion={profileCompletion}
        />
      ),
    },
    {
      title: 'SkillsForm',
      component: (
        <SkillsForm
          setIsFading={setIsFading}
          updatePercentage={updatePercentage}
          profileCompletion={profileCompletion}
        />
      ),
    },
    {
      title: 'Social Media',
      component: (
        <SocialMediaForm
          setIsFading={setIsFading}
          updatePercentage={updatePercentage}
          profileCompletion={profileCompletion}
        />
      ),
    },
    {
      title: 'General Questions',
      component: (
        <GeneralQuestionsForm
          setIsFading={setIsFading}
          profileData={profileData}
          setprofileData={setprofileData}
          loadApplicant={loadApplicant}
          updatePercentage={updatePercentage}
          profileCompletion={profileCompletion}
        />
      ),
    },
  ]

  const loadPercentage = () => {
    loadCurrentApplicantCompletion({
      userToken,
    }).then((result) => {
      if (typeof result === 'number') {
        setprofileCompletion(result)
        localStorage?.setItem('profileCompletion', result)
      }
    })
  }

  const loadAppliedJobs = () => {
    loadMyApplicationOverview({
      userToken,
    }).then((result) => {
      if (Array.isArray(result)) {
        setJobAppliedTotal(result.length)
      }
    })
  }

  if (!applicantID) {
    return <Navigate to={`/${language || lang || 'id'}/login`} replace />
  }

  return (
    <div>
      <div className='relative mx-auto mt-6 flex w-full max-w-[1200px] flex-col gap-6 pb-4 px-4 md:mt-12 md:px-6 lg:flex-row lg:items-start lg:px-4'>
        <ProfileSidebar
          profileData={profileData}
          jobAppliedTodal={jobAppliedTotal}
          profileCompletion={profileCompletion}
          showEditProfileButton={false}
        />
        <div className='w-full min-w-0 flex-1 md:-mt-4'>
          <div
            className={`transition-opacity duration-200 ${isFading ? 'opacity-0' : 'opacity-100'}`}
          >
            {tabs[currentTabIndex]?.component}
          </div>
        </div>
      </div>
    </div>
  )
}

export default function ProfilePage() {
  return (
    <ProfileTabProvider>
      <ProfilePageContent />
    </ProfileTabProvider>
  )
}
